import React from "react"
import clsx from "clsx"
import { createDomMotionComponent } from "framer-motion"

import { Asset, Link } from "components"

const MotionLink = createDomMotionComponent(Link)

const cardVariants = {
  initial: {
    scale: 1,
    transition: { type: "spring", bounce: 0.25, duration: 1 },
  },
  hover: {
    scale: 1.025,
    transition: { type: "spring", bounce: 0.25, duration: 0.5 },
  },
}

function VarietyCard({ name, image, size, slug }) {
  return (
    <li
      className={clsx(
        "flex min-h-[300px]",
        size === "Large" ? "col-span-2" : "col-span-1"
      )}
    >
      <MotionLink
        href={"/products/" + slug + "/"}
        className="relative flex flex-col w-full text-left text-white bg-white focus:outline-none"
        initial="initial"
        whileHover="hover"
        variants={cardVariants}
      >
        {image && (
          <Asset
            asset={{ ...image, gatsbyImageData: image.large }}
            objectFit="cover"
            objectPosition="center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        )}
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-25" />
        <div className="relative w-full pr-6 top-6 left-6">
          <p className="text-current h4">Explore {name}</p>
        </div>
      </MotionLink>
    </li>
  )
}

export default VarietyCard
